import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { SearchClientService } from "@app2/clients/search-client.service";
import { ImportantFieldData } from "@app2/search/search-shared/search-results-table.component";
import { NotificationsService } from "@app2/shared/services/notifications.service";
import { SearchRangeRequest, SearchWatchlistFilter } from "@app2/type-defs/search/search-types";

@Component({
    selector: "events-table",
    template: `
        <ng-container *dsLoading="loading">
            <search-results-table *ngIf="esEvents.length > 0"
                                  class="small-16 columns limit-results-height"
                                  [entries]="esEvents"
                                  [customColumns]="customColumns"
                                  [filterable]="false"
                                  [selectable]="false"
                                  [copyable]="true"
                                  (importantFieldDataChanged)="importantFieldDataChanged.emit($event)">
            </search-results-table>
        </ng-container>
    `,
})
export class EventsTableComponent implements OnChanges {
    @Input() queryString: string;
    @Input() begin: Moment;
    @Input() end: Moment;
    @Input() filterList: SearchWatchlistFilter;
    @Input() excludeList: SearchWatchlistFilter;
    @Input() customColumns: string[];

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onEventsFetched = new EventEmitter<number>();
    @Output() importantFieldDataChanged = new EventEmitter<ImportantFieldData[]>();

    loading: boolean;
    esEvents: any[] = [];

    constructor(private notificationsService: NotificationsService,
                private searchClient: SearchClientService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.queryString && !changes.begin && !changes.end) {
            return;
        }

        if (!this.queryString || !this.begin || !this.end) {
            return;
        }

        this.loading = true;

        const searchRequest = EventsTableComponent.topNHitsQuery(this.queryString, this.begin, this.end, this.filterList, this.excludeList);

        this.searchClient.searchRange(searchRequest)
            .then(entries => {
                this.esEvents = entries.hits;
                this.onEventsFetched.emit(this.esEvents.length);
            })
            .catch(err => this.notificationsService.showError("UNEXPECTED_COMMUNICATION_ERROR", err))
            .finally(() => this.loading = false);
    }

    private static topNHitsQuery(queryString: string, begin, end, filterList, excludeList): SearchRangeRequest {
        return {
            queryString,
            begin,
            end,
            include: filterList,
            exclude: excludeList,
            pageNumber: 1,
            pageSize: 20,
            sortField: "timestamp",
            sortDesc: true,
        };
    }
}
